import { memo } from "react";

import PositiveIcon from "../../../icons/PositiveIcon";
import NegativeIcon from "../../../icons/NegativeIcon";
import Skeleton from "../../../Skeleton/Skeleton";
import NoData from "../NoData/NoData";

import { VisibilityValueProps } from "./types";

const VisibilityValue = memo(function VisibilityValue({ value, loader }: VisibilityValueProps) {
  if (loader) return <Skeleton height={32} width={32} />;
  if (value === 1) return <PositiveIcon />;
  if (value === 0) return <NegativeIcon />;
  return <NoData />;
});

export default VisibilityValue;

